export const HEALTH_TOOLS_COMPLETED =
  'Thank you for taking the time to share your feedback and for helping make MyHealth+ a better experience for all our patients.';

export const DATA_CENTER_ID = 'sjc1';

export const SURVEY_ID = 'SV_5AbbzYsXXtxheQu';

export const SESSION_URL = `https://${DATA_CENTER_ID}.qualtrics.com/API/v3/surveys/${SURVEY_ID}/sessions`;
